export const FormLabel = {
  transclude: true,

  bindings: {
    for: '@',
  },

  template: `
    <label class="text-gray-900"
      for="{{ $ctrl.for }}"
      ng-transclude>
    </label>`,
};



// WEBPACK FOOTER //
// ./src/components/FormElements/FormLabel.js